import { useEffect } from 'react';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { QueryClient } from '@tanstack/react-query';
import { AuthContextType } from '@/contexts/AuthContext';
import { ErrorBoundary, ErrorNotification, ErrorDebugPanel } from '@/components/errors';
import { customerConfig } from '@/config/customerConfig';

export interface RouterContext {
  auth: AuthContextType;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  useEffect(() => {
    // Set document title based on customer configuration
    document.title = customerConfig.appTitle || 'Canvas App';
  }, []);

  // Styling is entirely Tailwind v4 + shadcn/ui now — the design tokens come from
  // the subsidiary CSS variables imported in main.tsx (`./themes`), and Tailwind's
  // preflight provides the baseline reset that MUI's CssBaseline used to.
  return (
    <ErrorBoundary>
      <ErrorNotification />
      <ErrorDebugPanel />
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </ErrorBoundary>
  );
}
